export default __webpack_public_path__ + "static/media/ENG. AMBIENTAL.edbcba52.pdf";